import LoadingIndicator from './loading_indicator';

export default LoadingIndicator;
